import {
  ROUTE_OPTIONS,
  setNavigatedLocationState,
} from '@exploring-infinities/meet';
import type { RouteOption } from '@exploring-infinities/meet';
import { useNavigate, useParams, useSearchParams } from 'react-router';

import Logo from '@/assets/icons/bhanzu-maverick-logo.svg';
import VB1 from '@/assets/images/VB1.png';
import { env } from '@/config/env';
import { useProfilesData } from '@/features/user';

const useConsumerHandlerData = () => {
  const navigate = useNavigate();
  const { meetingId, parentMeetingId } = useParams();
  const [search] = useSearchParams();
  const { selectedProfile, parentAppDownloaded } = useProfilesData();

  const navigateTo = async (
    routeOption: RouteOption,
    options?: {
      meetingId?: string;
      parentMeetingId?: string;
      preserveSearch?: boolean;
      replace?: boolean;
    },
    state?: Record<string, unknown>
  ) => {
    let url: string = '';

    switch (routeOption) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      case ROUTE_OPTIONS.HOME: {
        url = '/';

        break;
      }
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      case ROUTE_OPTIONS.MEETING: {
        url = `/maverick/class/${options?.meetingId}`;

        break;
      }
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      case ROUTE_OPTIONS.BREAKOUT_ROOM: {
        url = `/maverick/class/${options?.parentMeetingId}/br/${options?.meetingId}`;

        break;
      }
      // No default
    }
    if (!url) return;
    if (options?.preserveSearch) {
      url += `?${search.toString()}`;
    }
    if (state) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      setNavigatedLocationState(state);
    }

    await navigate(url, { replace: options?.replace ?? false });
  };

  return {
    actions: {
      navigateTo,
    },
    virtualBackgroundOptions: [
      {
        image: VB1,
        label: 'Orange 1',
        value: 'orange-01',
      },
    ],
    logo: Logo,
    meetingId,
    parentMeetingId,
    apiBaseUrl: env.API_URL ?? '',
    env: env.NODE_ENV ?? '',
    userDetails: {
      name: selectedProfile?.name ?? '',
      parentAppDownloaded,
    },
    sharpenUpQuizComponent: undefined,
    mockApi: env.ENABLE_API_MOCKING,
    accessedFrom: 'STUDENT_APP',
    studentAppURL: env.OLD_APP_URL,
    wsServerUrl: env.WS_SERVER_URL ?? '',
  };
};

export default useConsumerHandlerData;
